import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS } from "@/lib/business";

const navItems = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <div className="w-9 h-9 bg-blue-900 text-white grid place-items-center font-display font-black text-lg tracking-tight">
            R
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-slate-900 text-lg tracking-tight">
              {BUSINESS.name}
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-slate-500 font-semibold">
              Repair · {BUSINESS.serviceArea}
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `text-sm font-semibold tracking-wide uppercase transition-colors ${
                  isActive
                    ? "text-blue-900"
                    : "text-slate-600 hover:text-slate-900"
                }`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-btn"
            className="inline-flex items-center gap-2 bg-blue-900 hover:bg-blue-800 text-white px-5 py-2.5 text-sm font-semibold tracking-wide transition-colors"
          >
            <Phone className="w-4 h-4" />
            {BUSINESS.phone}
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-slate-900"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`m-${item.testid}`}
                className={({ isActive }) =>
                  `text-sm font-semibold uppercase tracking-wide py-2 ${
                    isActive ? "text-blue-900" : "text-slate-700"
                  }`
                }
                end={item.to === "/"}
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href={BUSINESS.phoneHref}
              data-testid="mobile-call-btn"
              className="inline-flex items-center justify-center gap-2 bg-blue-900 text-white px-5 py-3 text-sm font-semibold mt-2"
            >
              <Phone className="w-4 h-4" />
              {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
